import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";

export const REAL_ESTATE_AGENT = 'real-estate-agent';
export const REAL_ESTATE_BROKER = 'real-estate-broker';
export const MORTGAGE_LOAN_ORIGINATOR = 'mortgage-loan-originator';

class ProfessionalLicenseAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'professional-license';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'professionals/licenses';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'userUuid',
      'type',
      'state',
      'issuingBody',
      'number',
      'user',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      user: UserAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      user: "user_uuid",
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      userUuid: {
        presence: true,
        type: 'string',
      },

      type: {
        presence: true,
        type: 'string',
      },

      state: {
        presence: true,
        length: {
          maximum: 2,
        },
      },

      issuingBody: {
        presence: true,
        type: 'string',
      },

      number: {
        presence: true,
        type: 'string',
      },
    };
  }
}

export default ProfessionalLicenseAppResource;
